/**
 * Customer testimonials. ONLY authentic reviews with a verifiable source (e.g. Google Business Profile,
 * Facebook, Yelp) and the reviewer's permission/public posting. No invented names, faces, ratings or badges.
 *
 * Checked Oct 6, 2026: instamoversfl.com/pages/instamovers-reviews shows quotes attributed to
 * "John Smith" (twice), "Emily Johnson", "Michael Williams", "Susan Johnson", "Mike Williams" — these
 * match template placeholder patterns and have no linked source, so they are NOT republished here.
 * The section stays hidden until real entries are added.
 */
export interface Testimonial {
  quote: string;
  name: string;
  /** e.g. "Google review" */
  source: string;
  sourceUrl: string;
  /** ISO date of the review. */
  date: string;
  rating?: number;
}

export const testimonials: Testimonial[] = [];

/** Public review profile (e.g. Google Business Profile). null until the owner supplies it. */
export const reviewProfileUrl: string | null = null;
